import styled, { keyframes, css } from "styled-components";
import { ANIMATION, QUERIES, SPACING } from "../../utils/constants";

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const enterAnimation = (delay: string) => css`
  @media (prefers-reduced-motion: no-preference) {
    opacity: 0;
    animation: ${fadeUp} ${ANIMATION.duration.slow}
      ${ANIMATION.easing.easeOutQuint} ${delay} forwards;
  }
`;

export const FullPageWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: var(--color-background-0);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.xl}px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 480px;
  width: 100%;
`;

export const NotFoundNumber = styled.div`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-display-xl);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--color-text-muted);
  margin-bottom: ${SPACING.lg}px;
  ${enterAnimation("0ms")}

  @media ${QUERIES.tabletAndDown} {
    font-size: var(--text-display-lg);
  }
`;

export const NotFoundTitle = styled.h2`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-display);
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.015em;
  color: var(--color-text-default);
  margin-bottom: ${SPACING.md}px;
  ${enterAnimation("80ms")}
`;

export const NotFoundDescription = styled.p`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  font-weight: 400;
  line-height: 1.7;
  color: var(--color-text-secondary);
  max-width: 45ch;
  margin-bottom: ${SPACING.xl}px;
  ${enterAnimation("160ms")}
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${SPACING.md}px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: ${SPACING.lg}px;
  ${enterAnimation("240ms")}

  @media ${QUERIES.tabletAndDown} {
    flex-direction: column;
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const HelpText = styled.p`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xs);
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.025em;
  color: var(--color-text-muted);
  ${enterAnimation("320ms")}
`;
